import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDebounce } from '../../../../Hooks/useDebounce';
import TextField from '@mui/material/TextField';

const EditorTitle = function EditorTitle({
  id,
  edit = false,
  onChange = () => {},
  ...props
}) {
  const intl = useIntl();
  const { content, style } = props;
  const [value, setValue] = useState(content);
  const [debouncedValue] = useDebounce(value, 600); //wait after finish typing

  const handleChangeValue = (event) => {
    setValue(event.target.value);
  };
  useEffect(() => {
    setValue(content);
  }, [content]);

  useEffect(() => {
    if (debouncedValue)
      onChange({
        id,
        ...props,
        content: debouncedValue,
      });
  }, [debouncedValue]);

  return edit ? (
    <TextField
      fullWidth
      multiline
      onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      placeholder={intl.messages.TITLE}
      value={value}
      onChange={handleChangeValue}
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'unset',
        },
        '& .MuiInputBase-root': {
          color: '#111',
          padding: 0,
        },
      }}
      slotProps={{
        htmlInput: {
          style: {
            fontSize: '2rem',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            margin: 0,
            padding: '4%',
            ...style,
          },
        },
      }}
    />
  ) : (
    <h1
      id={id}
      style={{
        fontSize: '2rem',
        fontFamily: 'Roboto',
        margin: 0,
        padding: '4%',
        ...style,
      }}
    >
      {content}
    </h1>
  );
};

export default EditorTitle;
